import { MAN_TO_YEN, MY_BID_ESTATE, NUMBER_EN_US_FORMAT } from '@/constants/common';
import {
  MANAGEMENT_METHOD_TEXT,
  REMUNERATION_TYPE_TEXT,
  TRANSACTION_MODE_TEXT,
  TRANSPORT_METHOD,
  TRANSPORT_METHOD_BUS,
  TRANSPORT_METHOD_CAR,
  TRANSPORT_METHOD_FOOT,
  WON_BID_STATUS_TEXT,
  YES_NO_QUESTION,
} from '@/constants/estate';
import { BIDDING_STATUS } from '@/constants/eventBidding';
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';

/* eslint-disable */
export default function () {
  const store = useStore();
  const $formatNumber = inject('$formatNumber');

  const estate = computed(() => store.getters['estate/estate']);
  const estateCategories = computed(() => store.getters['common/estateCategories']);
  const structureCategories = computed(() => store.getters['common/structureCategories']);
  const buildingMapCategories = computed(() => store.getters['common/buildingMapCategories']);
  const landOwnershipCategories = computed(() => store.getters['common/landOwnershipCategories']);
  const situationCategories = computed(() => store.getters['common/situationCategories']);
  const typeOfLandCategories = computed(() => store.getters['common/typeOfLandCategories']);
  const useOfAreaCategories = computed(() => store.getters['common/useOfAreaCategories']);
  const districtCategories = computed(() => store.getters['common/districtCategories']);
  const rentalManagementCategories = computed(
    () => store.getters['common/rentalManagementCategories']
  );
  const prefectureCategories = computed(() => store.getters['common/prefectureCategories']);

  const dataInput = computed(() => {
    return JSON.parse(localStorage.getItem(MY_BID_ESTATE));
  });

  const priceInput = computed(() => {
    return dataInput.value?.price_input * MAN_TO_YEN ?? 0;
  });

  const isMobile = computed(() => store.getters['common/isLogin']);

  const bidderFee = computed(() => {
    if (estate.value?.monthly_plan?.bidder_fee_type === 2) {
      return (
        (parseFloat(priceInput.value) * parseFloat(estate.value?.monthly_plan?.bidder_fee_rate)) /
        100
      ).toFixed();
    }

    return parseFloat(estate.value?.monthly_plan?.bidder_fee_rate).toFixed() ?? 0;
  });

  const totalFee = computed(() => {
    return parseFloat(bidderFee.value) + parseFloat(priceInput.value);
  });

  const getEstateInfo = (estate) => {
    let estateInfo = _.cloneDeep(estate);

    estateInfo.type =
      estateCategories.value?.find((el) => el.code_id === estateInfo?.type?.toString())
        ?.code_name ?? '';
    estateInfo.structure =
      structureCategories.value?.find((el) => el.code_id === estateInfo?.structure?.toString())
        ?.code_name ?? '';
    estateInfo.building_map =
      buildingMapCategories.value?.find((el) => el.code_id === estateInfo?.building_map?.toString())
        ?.code_name ?? '';
    estateInfo.land_ownership =
      landOwnershipCategories.value?.find(
        (el) => el.code_id === estateInfo?.land_ownership?.toString()
      )?.code_name ?? '';
    estateInfo.situation =
      situationCategories.value?.find((el) => el.code_id === estateInfo?.situation?.toString())
        ?.code_name ?? '';
    estateInfo.type_of_land =
      typeOfLandCategories.value?.find((el) => el.code_id === estateInfo?.type_of_land?.toString())
        ?.code_name ?? '';
    estateInfo.use_of_area =
      useOfAreaCategories.value?.find((el) => el.code_id === estateInfo?.use_of_area?.toString())
        ?.code_name ?? '';
    estateInfo.district =
      districtCategories.value?.find((el) => el.code_id === estateInfo?.district?.toString())
        ?.code_name ?? '';
    estateInfo.rental_management_method =
      rentalManagementCategories.value?.find(
        (el) => el.code_id === estateInfo?.rental_management_method?.toString()
      )?.code_name ?? '';
    estateInfo.prefecture =
      prefectureCategories.value?.find((el) => el.code_id === estateInfo?.prefecture?.toString())
        ?.code_name ?? '';

    return estateInfo;
  };

  const titlePriceBidding = (totalBidding) => {
    if (!totalBidding) {
      return '開始価格';
    }
    return '現在価格';
  };

  const getTitleByValue = (value, type) => {
    let name = '';
    switch (type) {
      case 'transport_method1':
      case 'transport_method2':
      case 'transport_method3':
        switch (value) {
          case TRANSPORT_METHOD_FOOT:
            name = TRANSPORT_METHOD[TRANSPORT_METHOD_FOOT];
            break;
          case TRANSPORT_METHOD_CAR:
            name = TRANSPORT_METHOD[TRANSPORT_METHOD_CAR];
            break;
          case TRANSPORT_METHOD_BUS:
            name = TRANSPORT_METHOD[TRANSPORT_METHOD_BUS];
            break;
          default:
            break;
        }
        break;
      case 'biddingStatus':
        name = BIDDING_STATUS[value - 1].status_label;
        break;
      case 'wonBidStatus':
        name = WON_BID_STATUS_TEXT[value - 1];
        break;
      case 'management_method':
        name = MANAGEMENT_METHOD_TEXT[value - 1];
        break;
      case 'transaction_mode':
        name = TRANSACTION_MODE_TEXT[value - 1];
        break;
      case 'remuneration_type':
        name = REMUNERATION_TYPE_TEXT[value - 1];
        break;
      case 'parking_motobike':
      case 'parking_car':
      case 'parking_bike':
        name = YES_NO_QUESTION[value - 1];
        break;
      default:
        break;
    }
    return name;
  };

  const convertNumber = (numberInput) => {
    return $formatNumber(numberInput, NUMBER_EN_US_FORMAT);
  };

  return {
    estate,
    dataInput,
    bidderFee,
    totalFee,
    priceInput,
    isMobile,
    titlePriceBidding,
    getTitleByValue,
    convertNumber,
    getEstateInfo,
  };
}
